/*
 *
 * Settings constants
 *
 */

const BASE_ACTION_CONSTANT = 'app/Settings';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SPLIT_SCHEME_CONFIGURATION = 'split-scheme-configuration';

export const PAYMENT_METHODS = 'PAYMENT_METHODS';

export const PAYMENT_METHODS_HELP_LINK =
  'https://docs.cashfree.com/docs/activate-payment-methods#activating-payment-mode';

export const WALLET_DETIALS = 'wallet-details';

export const REMOVE_NAVIGATE_BACK_BTN = [
  SPLIT_SCHEME_CONFIGURATION,
  WALLET_DETIALS,
];

export const HIDE_BACK_BTN = ['WALLET-DETAILS'];

export const WALLETS = 'WALLETS';

export const BRANDING = 'BRANDING';

export const SFTP = 'SFTP';

export const REFUND_WALLET_DOC_LINK =
  'https://docs.cashfree.com/docs/refund-wallets';

export const HIDE_SETTINGS_HEADER = [
  PAYMENT_METHODS,
  SPLIT_SCHEME_CONFIGURATION,
  BRANDING,
];
